// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1SoAE","productName":"Table_productName__3K1sx"};